"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBillingContactPortalDto = instanceOfBillingContactPortalDto;
exports.BillingContactPortalDtoFromJSON = BillingContactPortalDtoFromJSON;
exports.BillingContactPortalDtoFromJSONTyped = BillingContactPortalDtoFromJSONTyped;
exports.BillingContactPortalDtoToJSON = BillingContactPortalDtoToJSON;
exports.BillingContactPortalDtoToJSONTyped = BillingContactPortalDtoToJSONTyped;
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the BillingContactPortalDto interface.
 */
function instanceOfBillingContactPortalDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('stripeCustomerId' in value) || value['stripeCustomerId'] === undefined)
        return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined)
        return false;
    if (!('isBilling' in value) || value['isBilling'] === undefined)
        return false;
    if (!('portalLink' in value) || value['portalLink'] === undefined)
        return false;
    return true;
}
function BillingContactPortalDtoFromJSON(json) {
    return BillingContactPortalDtoFromJSONTyped(json, false);
}
function BillingContactPortalDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'address': (0, AddressDto_1.AddressDtoFromJSON)(json['address']),
        'stripeCustomerId': json['stripeCustomerId'],
        'isPrimary': json['isPrimary'],
        'isBilling': json['isBilling'],
        'portalLink': json['portalLink'],
    };
}
function BillingContactPortalDtoToJSON(json) {
    return BillingContactPortalDtoToJSONTyped(json, false);
}
function BillingContactPortalDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'address': (0, AddressDto_1.AddressDtoToJSON)(value['address']),
        'stripeCustomerId': value['stripeCustomerId'],
        'isPrimary': value['isPrimary'],
        'isBilling': value['isBilling'],
        'portalLink': value['portalLink'],
    };
}
//# sourceMappingURL=BillingContactPortalDto.js.map